import { Form, Formik } from 'formik';
import React from 'react';

import AutoSave from '@components/AutoSave';
import { CheckBoxField } from '@components/FormFields';
import Spinner from '@components/Spinner';
import { usePrivacySettings, usePrivacySettingsUpdate } from '@hooks';

import SettingsHeading from '../SettingsHeading';
import schema from './schema';
import styles from './styles.module.scss';

const Privacy = () => {
  const { privacySettings, isLoadingPrivacySettings } = usePrivacySettings();
  const { mutate: updatePrivacySettings, showSave } = usePrivacySettingsUpdate();

  const handleSubmit = ({ ccpaDoNotSellPersonalInfo }) => {
    const sanitizedParams = {
      user: {
        ccpa_do_not_sell_personal_info: ccpaDoNotSellPersonalInfo,
      },
    };
    updatePrivacySettings(sanitizedParams);
  };

  if (isLoadingPrivacySettings) return <Spinner />;

  return (
    <div>
      <SettingsHeading title="Privacy Rights" />
      <Formik
        onSubmit={handleSubmit}
        initialValues={{
          ccpaDoNotSellPersonalInfo: privacySettings.ccpaDoNotSellPersonalInfo,
        }}
        validationSchema={schema}
      >
        {() => (
          <Form>
            <AutoSave debounceMs={500} />
            <div className={styles.privacyContainer}>
              <CheckBoxField
                name="ccpaDoNotSellPersonalInfo"
                label={
                  <>
                    <span className={styles.mainText}>
                      Do Not &quot;Sell&quot; My Personal Information
                    </span>
                    <div className={styles.saveContainer}>{showSave && <span>Saved</span>}</div>
                    <span className={styles.subText}>
                      We never exchange your personal information for money. We do provide your
                      information to outside services such as social networks so that they can
                      tailor your content for your interest in The Information.
                    </span>
                  </>
                }
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Privacy;
